import {ImportarDadosBancariosService} from './../../services/importar-dados-bancarios.service';
import {Component, OnInit, ViewChild, ElementRef, ChangeDetectionStrategy} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {BaseFormService} from 'src/app/services/base-form.service';
import {take} from 'rxjs/operators';
import { HttpResponse } from '@angular/common/http';
import {FilenameParser} from '@utils/FilenameParser';
import {FileDownloadService} from '@services/file-download.service';
import {HomeService} from '@services/home.service';
import { capturarArquivo, cancelarCapturaArquivo} from '@utils/file-upload.utils';
import { LoadingGenericoComponent } from '../../components/loading-generico/loading-generico.component';
import { HeaderComponent } from '../../components/header/header.component';
import { BotaoChatComponent } from '../../components/botao-chat/botao-chat.component';
import { AlertErroPadraoComponent } from '../../components/alert-erro-padrao/alert-erro-padrao.component';
import { AlertAtencaoPadraoComponent } from '../../components/alert-atencao-padrao/alert-atencao-padrao.component';
import { AlertDescartarAlteracoesComponent } from '../../components/alert-descartar-alteracoes/alert-descartar-alteracoes.component';
import { AlertSucessoPadraoComponent } from '../../components/alert-sucesso-padrao/alert-sucesso-padrao.component';
import { BreadcrumbComponent } from '../../components/breadcrumb/breadcrumb.component';
import { FileUploadAreaComponent } from '../../components/file-upload-area/file-upload-area.component';
import { NgClass, AsyncPipe, DatePipe } from '@angular/common';
import { SelectComponent } from '../../components/select/select.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { FooterComponent } from '../../components/footer/footer.component';
import { UsuarioPermissaoPipe } from '../../pipes/usuario-permissao.pipe';

@Component({
    selector: 'app-importar-dados-bancarios',
    templateUrl: './importar-dados-bancarios.component.html',
    styleUrls: ['./importar-dados-bancarios.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [LoadingGenericoComponent, HeaderComponent, BotaoChatComponent, AlertErroPadraoComponent, AlertAtencaoPadraoComponent, AlertDescartarAlteracoesComponent, AlertSucessoPadraoComponent, BreadcrumbComponent, FileUploadAreaComponent, NgClass, SelectComponent, NgxPaginationModule, FooterComponent, AsyncPipe, DatePipe, UsuarioPermissaoPipe]
})
export class ImportarDadosBancariosComponent extends BaseFormService implements OnInit {

  @ViewChild('inputFile', {static: true})
  public inputFile: ElementRef;
  public file = new FormData();
  public nomeArquivo = '';
  public comparador: any;
  public checkArquivo = false;
  public loadingGenerico = false;
  public tipoArquivo: any;
  public empresa: any = localStorage.idEmpresaLogada;
  public resources: any = [];
  public totalRegistros: any;
  public paginationTotal: any;
  public concluir = false;
  public naoTemRegistro = false;
  public alertSucesso = false;
  public erro = false;
  public alertErroSubtitulo: any = 'Erro ao adicionar arquivo !';
  public alertErroMensagem = '';
  public form: UntypedFormGroup;
  listaExtensoes: any;
  dataHoje: Date = new Date();
  processandoDados = false;
  showAlertErro = false;
  showAlertConcluirAtualizacao = false;
  descricaoAlertaAtualizacao: any;
  tituloAlertaAtualizacao: any;
  showAlertDescarte = false;
  dadosImportacao: any;
  descricaoSucesso: any = 'Dados bancários importados com sucesso.';
  descricaoErro: string = 'Não foi possível processar sua requisição. Revise o arquivo importado.'

  constructor(private readonly Toastr: ToastrService,
              private readonly formBuilder: UntypedFormBuilder,
              private readonly importarDadosBancariosService: ImportarDadosBancariosService,
              private readonly homeService: HomeService) {
    super();
    this.pagination.pageSize = '5';
  }

  ngOnInit(): void {
    this.getApiData();
    this.createForm();
    this.getListaExtensoes();

  }

  private createForm() {
    this.form = this.formBuilder.group({
      file: ['', [Validators.required]],
    });
  }

  public capturarArquivo(event: any) {
    capturarArquivo(event, this, this.inputFile, this.Toastr, this.listaExtensoes ?? []);
    if (!this.checkArquivo) {
      this.descricaoErro = 'Extensão do arquivo é inválida';
      this.showAlertErro = !!(event.target.files?.[0]);
    }
  }

  public cancelarCapturaArquivo() {
    cancelarCapturaArquivo(this, this.inputFile, this.Toastr);
  }

  public isErrorField(field) {
    return (this.form.get(field).valid === false && (this.form.get(field).touched === true));
  }

  public pdf() {
    this.tipoArquivo = 'pdf';
  }

  public xls() {
    this.tipoArquivo = 'xls';
  }

  public getArquivo() {
    this.loadingGenerico = true;
    this.importarDadosBancariosService.getArquivo(this.empresa, this.tipoArquivo).pipe(take(1))
    .subscribe({
      next: ({body, headers}: HttpResponse<any>) => {
        this.loadingGenerico = false;
        const filename = FilenameParser.fromContentDispositionHeader(
          headers.get('content-disposition'),
          'Arquivo.pdf',
        );
        FileDownloadService.download([body], filename);
      },
      error: (error) => {
        this.Toastr.error(error.error.mensagem, '', {
          timeOut: 2000,
        });
        this.loadingGenerico = false;
      }
    });
  }

  public setPagination(res) {

    this.pagination.totalPages = this.paginationTotal.totalPages;
    this.pagination.currentPageApi = this.paginationTotal.page;
    this.pagination.currentPagePaginator = this.paginationTotal.page + 1;
    this.pagination.pageSize = this.paginationTotal.size;
    this.pagination.totalElements = this.paginationTotal.total;

  }

  public getApiData() {

    const paramsArray = this.getParamsFormatArray();
    const paramsUrl = this.getParamsUrl(paramsArray);
    this.importarDadosBancariosService.getHistorico(this.empresa, paramsUrl)
    .pipe(take(1))
    .subscribe({
      next: (success: any) => {
        this.resources = success.response.data;
        this.paginationTotal = success.response.pageRequest;
        this.totalRegistros = success.response.pageRequest.total;
        this.setPagination(success);
        if (this.totalRegistros > 0 && this.resources.length == 0) {
          this.pagination.currentPagePaginator = 1;
          this.pagination.currentPageApi = 0;
          this.getApiData();
        }
        if (this.totalRegistros == 0) {
          this.naoTemRegistro = true;
        }
      },
      error: (error) => {
        console.error(error);
      }
    });
  }

  public getParamsFormatArray() {

    const arr = [];

    arr.push(
      {name: 'pagina', comparator: '=', value: this.pagination.currentPageApi},
      {name: 'tamanho', comparator: '=', value: this.pagination.pageSize}
    );

    return arr;

  }

  public enviarDadosVerificar() {
    this.processandoDados = true;
    this.importarDadosBancariosService.verificarOcorrencia(this.empresa, this.file).pipe(take(1))
    .subscribe({
      next: (response: any) => {
        if (response.status === 'OK') {
          this.tituloAlertaAtualizacao = 'Atualizar ' + response.response.registros + ' usuários?';
          this.descricaoAlertaAtualizacao = 'Deseja realizar atualização de usuários?';
          this.showAlertConcluirAtualizacao = true;
          this.dadosImportacao = response.response.importacaoDadosBancarios;
        }
        if (response.status === 'NOK') {
          this.descricaoErro = response.mensagem;
          this.showAlertErro = true;
        }
        this.processandoDados = false;
      },
      error: (erro) => {
        this.descricaoErro = erro.error.mensagem;
        this.showAlertErro = true;
        this.processandoDados = false;
      }
    });
  }

  private getListaExtensoes() {
    this.homeService.getExtensoes('importar-dados-bancarios').pipe(take(1)).subscribe({
      next: (success: any) => {
        this.listaExtensoes = success.extensions;
      },
      error: (error) => {
        console.error(error);
      }
    });
  }

  alertaErroFechou() {
    this.showAlertErro = false;
  }

  alertaAtencaoAtualizacaoFechou() {
    this.showAlertConcluirAtualizacao = false;
    this.showAlertDescarte = true;

  }

  cancelarAlteracoes(evento: any) {
    this.showAlertDescarte = false;
    this.limpaArquivoSelecionado();
  }

  limpaArquivoSelecionado(){
    this.checkArquivo = false;
    this.nomeArquivo = '';
    this.inputFile.nativeElement.value = '';
    this.dadosImportacao = [];
  }

  manterAlteracoes(evento: any) {
    this.showAlertDescarte = false;
    this.showAlertConcluirAtualizacao = true;

  }

  confirmouAtualizacao() {
    this.showAlertConcluirAtualizacao = false;
    this.loadingGenerico = true;
    this.importarDadosBancariosService.salvarImportacao
    (this.empresa, this.dadosImportacao).pipe(take(1))
    .subscribe({
      next: (response: any) => {
        this.loadingGenerico = false;
        this.alertSucesso = true;
        this.limpaArquivoSelecionado();
      },
      error: (erro) => {
        this.descricaoErro = erro.error.mensagem;
        this.loadingGenerico = false;
        this.showAlertErro = true;
        this.alertSucesso = false;
      }
    });
  }

  sucessoFechou() {
    this.getApiData();
    this.alertSucesso = false;
  }
}
